import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_collect_choose",
  "use": "icon-icon_collect_choose-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_collect_choose\"><path d=\"m9 17c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8z\" fill=\"#4bd214\" /><path d=\"m6.9 12.5-2.8-2.8c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.1 2.1 4.3-4.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5 5c-.3.4-1 .4-1.4 0z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon_collect_choose.svg
// module id = voQN
// module chunks = 87